import request from './request';


/**
 * 获取车险订单列表信息
 */
export function getInsuranceOrder(params) {
    return request('/insurance/order/list', {
        method: 'POST',
        params,
    });
}
/**
 * 获取车险订单详情
 */
export function getInsuranceOrderItem(params) {
    return request('/insurance/order/item', {
        method: 'GET',
        params,
    });
}
